<template>
  <v-container class="py-12">
    <TitleHeader> Contatos </TitleHeader>

    <v-row
      class="mt-12"
      justify="center"
      align="stretch"
      dense
    >
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-center"
      >
        <NavigationCard
          icon="mdi-email-edit-outline"
          title="Fale Conosco"
          to="/funarpen/contato/fale-conosco"
          color="light-green"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-center"
      >
        <NavigationCard
          icon="mdi-shield-search"
          title="LGPD"
          to="/funarpen/contato/lgpd"
          color="teal"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-center"
      >
        <NavigationCard
          icon="mdi-shield-alert-outline"
          title="Denúncia Tentativa de Fraude"
          to="/funarpen/contato/denuncia-tentativa-fraude"
          color="red"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import TitleHeader from '@/components/TitleHeader.vue'
import NavigationCard from '@/components/NavigationCard.vue'

definePageMeta({
  middleware: 'manutencao',
  title: 'FUNARPEN - Fale Conosco',
})

useHead({
  title: 'Fale Conosco - Contato FUNARPEN',
  meta: [{ name: 'description', content: 'Entre em contato com o FUNARPEN' }],
})
</script>
